import { render, staticRenderFns } from "./renewal-orders.vue?vue&type=template&id=4ff194f6&scoped=true"
import script from "./renewal-orders.vue?vue&type=script&lang=js"
export * from "./renewal-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff194f6",
  null
  
)

export default component.exports